export const BONUS_AMOUNTS = '/bonus/bonusAmount'
